import { Component, ElementRef, Input, ViewChild, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";

import { TAAConstants } from "../../../../views/constants/taa-constants";
import { AccommsService } from "../../../../views/services/accomms.service";
import { CommonService } from "../../../../views/services/common.service";
import { PersonService } from "../../../../views/services/person.service";
import { ReasonService } from "../../../../views/services/reason.service";
import { RequestSubmitService } from "../../../../views/services/requestsubmit.service";
import { PaperStepperComponent } from "../process-paper-request/stepper/paper-stepper.component";
import { AppService } from "../../../../views/services/app.service";


@Component({
    selector: 'app-accsupportreason',
    templateUrl: './accsupportreasons.component.html',
    styleUrls: ['./accsupportreasons.component.css']
})
export class AccSupportReasonsComponent implements OnInit {

    public taaPin: string;
    public frmReason: FormGroup;
    public disabilities: any[];
    public langDisabilities: any[];
    public personName: string;
    public validationErrors: any;
    public personDisabilities: any;
    public reconsideration: string;
    public user: string = "";
    public statusCd: string;
    public currentRecord: any;
    public requestId: any;
    public prevSavedFrmReason: any = { disabilityStatus: false, englishLearner: false };
    formSubmitted = false;
    public recordCount: "0";
    public savedReq: any;

    savedRequest: Request;
    frmReasonError: any = { showit: false, errorCount: 0 };
    @ViewChild('noReasonModalTrigger') noReasonModalTrigger: ElementRef;

    constructor(private fb: FormBuilder,
        public stepper: PaperStepperComponent,
        private router: Router,
        private reasonService: ReasonService,
        private personService: PersonService,
        public commonService: CommonService,
        public taaConstants: TAAConstants,
        public requestSubmitService: RequestSubmitService,
        private appService: AppService,
        private accommsService: AccommsService
    ) {

        this.frmReason = this.fb.group({
            disabilityStatus: [],
            disabilityCategories: this.fb.array([]),
            langDisability: this.fb.group({
                selected: [],
                otherDesc: []
            }),
            englishLearner: [],
            otherDisablityDesc: []
        });
    }

    validate = () => {
        if (!this.frmReason) {
            return;
        }
        const formData = this.frmReason.value;
        if ((_.isEmpty(formData.disabilityStatus)) || (_.isEmpty(formData.englishLearner))) {
            this.noReasonModalTrigger.nativeElement.click();
            return { requiredReason: false, errorCount: 0, case: '1a' };
        }
        if ((_.isEmpty(formData.disabilityStatus)) && (formData.englishLearner === 'no')) {
            this.noReasonModalTrigger.nativeElement.click();
            return { requiredReason: false, errorCount: 0, case: '1b' };
        }
        if ((formData.disabilityStatus === 'no') && (_.isEmpty(formData.englishLearner))) {
            this.noReasonModalTrigger.nativeElement.click();
            return { requiredReason: false, errorCount: 0, case: '1c' };
        }

        if (((formData.disabilityStatus === 'no') && (formData.englishLearner === 'no'))) {
            this.noReasonModalTrigger.nativeElement.click();
            return { requiredReason: false, errorCount: 0, case: 2 };
        }

        const selectedDisabilities = [];
        let otherDisablityDescError = false;

        formData.disabilityCategories.forEach(
            category => {
                category.disabilities.forEach(disability => {
                    if (disability.DISABILITY_DS === 'OTHER' && formData.otherDisablityDesc !== null) {
                        if ((formData.otherDisablityDesc !== '' || formData.otherDisablityDesc.trim() !== '')) {
                            otherDisablityDescError = !(this.regexTest(formData.otherDisablityDesc, 500));
                            disability.otherDesc = formData.otherDisablityDesc;
                            disability.checked = true;
                        }
                    }

                    if (disability.DISABILITY_DS === 'OTHER') {
                        if (formData.otherDisablityDesc === null || formData.otherDisablityDesc === '') {
                            otherDisablityDescError = false;
                            disability.checked = false;
                        }
                    }
                    if (disability.checked) {
                        selectedDisabilities.push(disability);
                    }
                });
            });


        let otherLangDisabilityError = false;
        if (formData.langDisability.selected.DISABILITY_NM === "ELL_VERBAL_INST") {
            otherLangDisabilityError = !this.regexTest(formData.langDisability.otherDesc, 32);
        }

        const validator = {
            hasDisabilityStatusSelected: formData.disabilityStatus === 'yes',
            hasDisabilityValuesSelected: !!selectedDisabilities.length,
            hasEnglishLearnerSelected: formData.englishLearner === 'yes',
            hasLangDisabilitySelected: !_.isEmpty(formData.langDisability.selected)
        };
        if (validator.hasDisabilityStatusSelected && !validator.hasDisabilityValuesSelected
            && validator.hasEnglishLearnerSelected && !validator.hasLangDisabilitySelected) {
            return { requiredDisability: true, requiredLangDisability: true, errorCount: 2, case: 3 };
        }
        if (validator.hasDisabilityStatusSelected && !validator.hasDisabilityValuesSelected) {
            return { requiredDisability: true, errorCount: 1, case: 4 };
        }
        if (validator.hasEnglishLearnerSelected && !validator.hasLangDisabilitySelected) {
            return { requiredLangDisability: true, errorCount: 1, case: 5 };
        }

        if (otherDisablityDescError && otherLangDisabilityError) {
            return { requiredDisability: true, requiredLangDisability: true, otherDisablityDescError: true, otherLangDisabilityError: true, errorCount: 2, case: 6 };
        }

        if (otherDisablityDescError) {
            return { requiredDisability: true, otherDisablityDescError: true, errorCount: 1, case: 7 };
        }
        if (otherLangDisabilityError) {
            return { requiredLangDisability: true, otherLangDisabilityError: true, errorCount: 1, case: 8 };
        }
        return null;
    }

    regexTest(str, length) {
        if (_.isEmpty(_.toString(str))) {
            return false;
        }
        if (str.length > length) {
            return false;
        }
        const pattern = /^[a-zA-Z0-9\.\s\,\'\:\;]{1,500}$/;
        const regex = new RegExp(pattern);
        return regex.test(str);
    }

    saveReasonData(proceed: boolean): void {
        this.validationErrors = this.validate();
        this.frmReasonError = { showit: false, requiredLangDisability: '', requiredDisability: '', errorCount: 0 };
        if (this.validationErrors) {
            const showit = this.validationErrors.requiredDisability || this.validationErrors.requiredLangDisability || false;
            this.frmReasonError = {
                showit: showit,
                requiredDisability: this.validationErrors.requiredDisability || false,
                requiredLangDisability: this.validationErrors.requiredLangDisability || false,
                otherDisablityDescError: this.validationErrors.otherDisablityDescError || false,
                otherLangDisabilityError: this.validationErrors.otherLangDisabilityError || false,
                errorCount: this.validationErrors.errorCount
            };
            return;
        }

        this.formSubmitted = true;
        const request: any = {
            requestId: this.savedReq.requestId,
            personId: this.savedReq.personId
        };
        const formData = this.frmReason.value;
        if (formData.disabilityStatus === 'yes') {
            request.selectedDisabilities = [];
            formData.disabilityCategories.forEach(
                category => {
                    category.disabilities.forEach(disability => {
                        if (disability.DISABILITY_DS === 'OTHER') {
                            disability.otherDesc = formData.otherDisablityDesc;
                        }
                        if (disability.checked) {
                            request.selectedDisabilities.push(disability);
                        }
                    });
                });
        }
        request.disabilityStatus = formData.disabilityStatus;
        request.englishLearner = formData.englishLearner;
        if (formData.englishLearner === 'yes') {
            request.langDisability = formData.langDisability;
        }
        this.removeDisabilityId(request, proceed);
    }

    removeDisabilityId(request, proceed) {
        if (_.isEmpty(this.personDisabilities)) {
            this.saveDisabilityId(request, proceed);
            return;
        }
        const responseOnDeletingRow = [];
        _.each(this.personDisabilities, (row) => {
            this.reasonService.removeIntPersonDisabilityById(row.PERSON_DISABILITY_ID).subscribe(
                (response) => {
                    responseOnDeletingRow.push(response || 'dummy text');
                    if (responseOnDeletingRow.length === this.personDisabilities.length) {
                        this.saveDisabilityId(request, proceed);
                    }
                },
            );
        });
    }

    saveDisabilityId(request, proceed) {
        this.reasonService.saveIntReasonRequest(request).subscribe(
            (data: any) => {
                if (proceed) {
                    sessionStorage.setItem("reasonSubmitted", 'true');
                    this.stepper.goToNextStep();
                }
                this.formSubmitted = false;
            }
        );
    }

    getPreviousRecordDetails = () => {
        this.stepper.goToPrevStep();
    }

    ngOnInit() {
        this.appService.getUserProfile().then(user => this.user = user.loggedInUser);
        sessionStorage.setItem("testSubmitted", '');
        if (sessionStorage.getItem("currentStudent")) {
            const studentDetails: any = JSON.parse(
                sessionStorage.getItem("currentStudent")
            );
            this.savedReq = studentDetails;
        }
        this.personName = this.savedReq ? this.savedReq.personName : '';
        this.taaPin = this.savedReq ? this.savedReq.taaPin : '';
        Observable.forkJoin(
            this.commonService.getDynContent('REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG'),
        ).subscribe(([reconsideration]) => {
            this.reconsideration = reconsideration;
        });
        this.getPersonDisability();
        this.getStatusCode();
    }

    getStatusCode() {
        this.accommsService.getInternalRequests(this.savedReq.requestId).subscribe(data => {
            this.accommsService.getRequestedStatusCode((data as any).REQUEST_STATUS_CODE_ID).subscribe(success => {
                this.statusCd = (success as any).STATUS_CD;
            },
            );
        });
    }

    getPersonDisability() {
        Observable.forkJoin(this.commonService.getFinishedRecordCount(this.savedReq.personId),
            this.personService.getInternalPersonDisabilityById(this.savedReq.personId)).subscribe(
                ([finishedRecordCount, response]) => {
                    this.recordCount = finishedRecordCount as any;
                    this.personDisabilities = response;
                    this.getDisabilities();
                }
            );
    }

    getDisabilities() {

        this.reasonService.getDisabilities().subscribe((response) => {
            const dis: any[] = <Array<any>>response;
            this.disabilities = [];
            this.langDisabilities = [];
            for (let i = 0; i < dis.length; i++) {
                if ((dis[i]['DISABILITY_CATEGORY_TYPE']) === 'A' || (dis[i]['DISABILITY_CATEGORY_TYPE']) === null) {
                    this.disabilities.push(dis[i]);
                } else {
                    this.langDisabilities.push(dis[i]);
                }
            }

            const catFGs = this.disabilities.map(category => {
                const disablilites = category['DISABILITY_DS'];
                const disabilitiesFGs = disablilites.map(disability => {
                    disability.checked = this.hasPersonCheckedThisDisability(disability);
                    return this.fb.group(disability);
                });
                return this.fb.group({
                    disabilities: this.fb.array(disabilitiesFGs)
                });
            });
            this.frmReason.setControl('disabilityCategories', this.fb.array(catFGs));
            let selectedLangDisability = {};
            _.each(this.personDisabilities, (disability) => {
                const matchingLangDisability = _.find(this.langDisabilities[0].DISABILITY_DS, { DISABILITY_ID: disability.DISABILITY_ID });
                if (!_.isEmpty(matchingLangDisability)) {
                    selectedLangDisability = matchingLangDisability;
                }
            });
            this.prevSavedFrmReason.englishLearner = !_.isEmpty(selectedLangDisability);
            this.frmReason.setControl('langDisability', this.fb.group({ selected: selectedLangDisability, otherDesc: '' }));
            if (this.prevSavedFrmReason.englishLearner) {
                this.frmReason.controls.englishLearner.setValue('yes');
            } else if (this.personDisabilities.length) {
                this.frmReason.controls.englishLearner.setValue('no');
            }
            if (this.prevSavedFrmReason.disabilityStatus) {
                this.frmReason.controls.disabilityStatus.setValue('yes');
            } else if (this.personDisabilities.length) {
                this.frmReason.controls.disabilityStatus.setValue('no');
            }
            if (this.personDisabilities.length) {
                const disabilitiesWithNm = _.map(response, (disability) => {
                    return { DISABILITY_DS: disability.DISABILITY_DS, DISABILITY_NM: disability.DISABILITY_NM, DISABILITY_CATEGORY_TYPE: disability.DISABILITY_CATEGORY_TYPE };
                });
                let disabilityOtherDescWithNM = '';
                let languageOtherDescWithNm = {};
                let languageOtherDescWithNmSelected = {};
                _.each(this.personDisabilities, (disability) => {
                    _.each(disabilitiesWithNm, (dds) => {
                        const matchingDDNM = _.find(dds.DISABILITY_DS, { DISABILITY_ID: disability.DISABILITY_ID });
                        if (!_.isEmpty(matchingDDNM)) {
                            if (matchingDDNM.DISABILITY_NM === 'O') {
                                disabilityOtherDescWithNM = disability.OTHER_DS;
                            }
                            if (dds.DISABILITY_CATEGORY_TYPE === 'E' || matchingDDNM.DISABILITY_NM === "ELL_VERBAL_INST") {
                                languageOtherDescWithNmSelected = matchingDDNM;
                                languageOtherDescWithNm = disability.OTHER_DS;
                            }
                        }
                    });
                });

                this.frmReason.controls.otherDisablityDesc.setValue(disabilityOtherDescWithNM);
                this.frmReason.setControl('langDisability', this.fb.group({
                    selected: languageOtherDescWithNmSelected,
                    otherDesc: languageOtherDescWithNm && Object.keys(languageOtherDescWithNm).length === 0 && languageOtherDescWithNm.constructor === Object ? '' : languageOtherDescWithNm
                }));

            }
        });
    }

    hasPersonCheckedThisDisability(disability) {
        const hasChecked = _.filter(this.personDisabilities, { DISABILITY_ID: disability.DISABILITY_ID });
        this.prevSavedFrmReason.disabilityStatus = this.prevSavedFrmReason.disabilityStatus || !_.isEmpty(hasChecked);
        return !_.isEmpty(hasChecked);
    }

    resetError(errorType) {
        if (errorType === 'disability') {
            this.frmReasonError.requiredDisability = false;
        }
        if (errorType === 'language') {
            this.frmReasonError.requiredLangDisability = false;
        }
    }

    setInputToEmpty() {
        this.frmReason.controls.langDisability.patchValue({
            otherDesc: ''
        });
    }

    reset() {
        this.frmReason.value.langDisability.selected = {};
    }

}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/accsupportreasons/accsupportreasons.component.ts